module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_android_permissions.46de54a74e011eeaf161f98169f81d09.png";